const demo_app = {
    notification: 'Consejo: Crea una cuenta primero para probar la experiencia de inicio de sesión.',
};
export default demo_app;
